const parties = {
  'AP': "Avoin Puolue",
  'EOP': "Eläinoikeuspuolue",
  'FP': "Feministinen puolue",
  'KAL': "Kansalaisliitto",
  'KD': "Suomen Kristillisdemokraatit",
  'KESK': "Suomen Keskusta",
  'KL': "Korjausliike",
  'KOK': "Kansallinen Kokoomus",
  'KRIP': "Kristallipuolue",
  'LIBE': "Liberaalipuolue - Vapaus valita",
  'LIIK': "Liike nyt",
  'PIR': "Piraattipuolue",
  'PS': "Perussuomalaiset",
  'RKP': "Svenska folkpartiet i Finland",
  'SDP': "Suomen Sosialidemokraattinen Puolue",
  'SIN': "Sinimusta Liike",
  'SKE': "Suomen Kansa Ensin",
  'SKP': "Suomen Kommunistinen Puolue",
  'SML': 'Sinimusta Liike',
  'STL': "Seitsemän tähden liike",
  'VAS': "Vasemmistoliitto",
  'VIHR': "Vihreä liitto",
  'VKK': "Valta kuuluu kansalle",
  'VL': "Vapauden liitto",
  'YL1': 'Lapin sitoutumattomat -yhteislista',
}

module.exports = parties